import {
  BuildingOfficeIcon,
  Cog8ToothIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { DropdownOption, DropdownSelector } from "./DropdownSelector";

export function ManagementSelector() {
  const navigate = useNavigate();
  const { t: tUser } = useTranslation(["userManagement"]);
  const { t: tUniversity } = useTranslation(["universityManagement"]);

  const options: DropdownOption[] = [
    {
      key: "users",
      label: tUser("userManagement"),
      icon: <UserIcon className="h-5 w-5" />,
      onClick: () => navigate("/admin/users"),
    },
    {
      key: "universities",
      label: tUniversity("universityManagement"),
      icon: <BuildingOfficeIcon className="h-5 w-5" />,
      onClick: () => navigate("/admin/universities"),
    },
  ];

  return (
    <DropdownSelector
      triggerIcon={<Cog8ToothIcon className="h-5 w-5" />}
      options={options}
    />
  );
}
